<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>智能升降柱</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>智能升降柱</h2>
          <p>
            本公司采用的机动车大门通道管理系统，采用新型自动升降 路桩（又名伸缩路桩、升降柱），液压一体升降柱（本文简 称升降柱），采用液压动力源和液压动作杆集成，双向一体 液压机芯。系统是采用微型电机通过一个集成阀件的连接块 与齿轮泵和油箱连接，然后与一体化液压缸装配而构成一个 完整的微型液压系统，通过结构件将该系统安装于路障主体
            的内部，完成了电能->机械能->液压能的完整转化过程，真 正实现了微型机、电、液一体化。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>快速平静</h2>
          <p>升降时间最快可达1.5秒，远远大于同等规格的升降 柱，这一点极其难能可贵。由于它采用液压驱动单元，动作起 来，柔和而平静，很好的解决了传统气动升降柱因气泵工作噪 音大的问题。</p>
        </li>
        <li>
          <h2>控制敏捷</h2>
          <p>控制单元采用多功能逻辑控制器，可以调制多种不 同的功能模式，以满足不同用户在功能上的不同需求。另外， 值得一提的是，其运动行程为可调式计时设计，用户可自由控制 柱子的升降高度，有效节省能源消耗。</p>
        </li>
        <li>
          <h2>结构独特</h2>
          <p>其核心部分液压单元与机械动力机构为一体式设 计，可有效地将机械能传递给液压驱动单元，动作高效。液压 单元实现压力直升的独特设计，性能卓越，在国内外同一领域 里是很少见的。</p>
        </li>
        <li>
          <h2>安全可靠</h2>
          <p>当遇停电等紧急情况时，可手运开启紧急下降按 钮，柱体降下，以开放通道，放行车辆。内部固定机构的上部 和下部分别装有电流检测传感器和电磁传感器，从而实现了对 动力单元的过流保护及柱体动作的有效限位，运行稳定可靠。</p>
        </li>
        <li>
          <h2>经济实惠</h2>
          <p>由于自身为液压传动一体模式，环保节能，低消 耗，故障率更低，使用寿命更长，降低了维护成本。另外，采 用非传统式导向机构设计，安装维护，更加简便快捷。</p>
        </li>
        <li>
          <h2>结构独特</h2>
          <p>其核心部分液压单元与机械动力机构为一体式设 计，可有效地将机械能传递给液压驱动单元，动作高效。液压 单元实现压力直升的独特设计，性能卓越，在国内外同一领域 里是很少见的。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SsintelligentLift',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 200px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
